import React from "react";
import { VMBuilder } from "../../../commons/base/providers/builder";
import MenuPreparationBomDashboardViewModel from "../view_models/menu_preparation_bom_view_model";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";
import SizedDiv from "../../../commons/ui/sized_div";

export default class MenuPreparationBomDashboardReadOnlyFormWidget extends React.Component {
    render(): React.ReactNode {
        return (
            <VMBuilder<MenuPreparationBomDashboardViewModel>>
                {(vm) => (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 max-h-screen p-2">
                        <div className="relative bg-white rounded-lg shadow-lg mt-10 p-5 w-full max-w-4xl max-h-[83vh] overflow-y-auto">
                            <button
                                className="text-red-500 absolute right-3 top-3"
                                onClick={() => vm.resetReadOnlyForm()}
                            >
                                <FontAwesomeIcon icon={faX} />
                            </button>

                            <SizedDiv height={12} />

                            <h1 className="font-bold">
                                {vm.readOnlyFormItemName}
                            </h1>

                            <div className="overflow-x-auto">
                                <table className="table-auto w-full text-center border-collapse my-2">
                                    <thead>
                                        <tr className="bg-gray-300">
                                            <th className="p-2 border border-gray-400 w-1/5">
                                                Nama Item
                                            </th>
                                            <th className="p-2 border border-gray-400 w-1/5">
                                                Material Code
                                            </th>
                                            <th className="p-2 border border-gray-400 w-1/5">
                                                Quantity
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {[...vm.readOnlyMprMap.values()].map(
                                            (mpr) => (
                                                <tr key={mpr.mprId}>
                                                    <td className="p-2 border border-gray-400">
                                                        {mpr.mprName}
                                                    </td>
                                                    <td className="p-2 border border-gray-400">
                                                        {mpr.mprMaterialCode}
                                                    </td>
                                                    <td className="p-2 border border-gray-400">
                                                        {mpr.mprQty}
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}
            </VMBuilder>
        );
    }
}
